<script setup lang="ts">
import { DxSelectBox } from 'devextreme-vue/select-box';
import { useCdpProjectContext } from '../composables/useCdpProjectContext';

defineProps({
  title: { type: String, required: true },
  requireProject: { type: Boolean, default: true },
});

const {
  projectOptions,
  selectedProjectId,
  selectProject,
  loading,
  hasProject,
} = useCdpProjectContext();

function onProjectChanged(e: { value?: string | null }) {
  selectProject(e.value ?? null);
}
</script>

<template>
  <div class="cdp-page">
    <header class="cdp-page__header">
      <h2 class="cdp-page__title">{{ title }}</h2>
      <div v-if="requireProject" class="cdp-page__project">
        <span class="cdp-page__project-label">Проект</span>
        <DxSelectBox
          :data-source="projectOptions"
          display-expr="text"
          value-expr="value"
          :value="selectedProjectId"
          :disabled="loading"
          width="280"
          placeholder="Выберите проект"
          @value-changed="onProjectChanged"
        />
      </div>
    </header>

    <div v-if="requireProject && !hasProject" class="cdp-page__banner">
      Выберите проект, чтобы загрузить данные.
    </div>

    <div v-else class="cdp-page__body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.cdp-page {
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  flex: 1;
}
.cdp-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.cdp-page__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.cdp-page__project {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cdp-page__project-label {
  font-size: 0.875rem;
  color: var(--dx-color-text-secondary, #666);
}
.cdp-page__banner {
  padding: 12px 16px;
  border-radius: 4px;
  background: #fff8e1;
  border: 1px solid #ffe082;
}
.cdp-page__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}
</style>
